var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-button',{staticClass:"demo-btn",staticStyle:{"margin":"0 auto"},attrs:{"to":{ name: _vm.ROUTE_NAME.DEMO },"name":"Записаться на демо","dataforce":"","size":"large"}})
}
var staticRenderFns = []

export { render, staticRenderFns }